import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SelectItem, ConfirmationService } from 'primeng/api';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { ManualService } from './../services/manual.services';
import { KubaGeneralService } from './../../kuba-general.services';
import { ManualView, ManualEdit } from './../models/index';
import { BaseServices } from './../../kuba.services';
import { ManualVersion } from 'src/app/kuba/manuals/models/manual-version';
import { UserRole } from '../../follow-ups/models/deviation';
import { TranslateService } from '@ngx-translate/core';
import { AdminUserService } from 'src/app/kuba/adminuser/services/adminuser.service';
import { BusinessServices } from 'src/app/kuba/businesses/services/business.services';
import { Subscription } from 'rxjs';
import { DateService } from 'src/app/_services/date.service';
@Component({
    selector: 'assignmanual',
    templateUrl: 'assignmanual.component.html',
    providers: [],
  standalone: false
})


export class AssignManualComponent implements OnInit {
    
    Portal = 'Portal';
    Business = 'Business';
    selectedType = 'Portal';
    typeList: SelectItem[];
    portalList: SelectItem[];
    businessList: SelectItem[];
    isAllCommonManual = true;
    CommonManuals: ManualView[];
    assignManuals: ManualView[];
    editCommonManual: ManualEdit[];
    GetManualEdit: ManualEdit[];
    objManualEdit: ManualEdit;
    userRole: number;

    levelId: number;
    levelKey: number = null!;
    appId: number;
    mode: number;

    showVersions = false;
    viewType = false;

    BusinessOrPortalList: ManualView[];
    SelectedPortalList: ManualView[];
    selectedCommonList: ManualView[];
    PortalCommonList: ManualView[];
    isAssigning = false;
    activeList: ManualView[];
    setbooleanTrue = true;
    setbooleanFalse = false;

    manualVersions: ManualVersion[];
    manualVersionId: any = null;
    manualVersionField: any = null;
    versionDetails: ManualVersion;
    manualVersionDropDown: SelectItem[];

    optionName: string;
    userList: SelectItem[];
    businessId: number;
    portalId: number;
    roleId: any;
    adminUser: any[];
    private subscriptions: Subscription[] = [];
    constructor(private route: ActivatedRoute,
        private manualService: ManualService, private kubaGeneralService: KubaGeneralService,
        private translate: TranslateService, private confirmationService: ConfirmationService,
        private businessService: BusinessServices,
        private dateService: DateService, private messageService: NotificationService
        ) {

        this.ShowHideCommonListColumns();
    }

    ngOnInit() {
        document.querySelector("body").classList.remove("opened");
        // Bind portal list
        this.portalList = [];
        if (+BaseServices.roleId !== UserRole.PORTAL) {
            this.subscriptions.push(this.kubaGeneralService.getPortalList().subscribe((result: any) => {
                if (result) {
                    result.forEach((element:any) => {
                        this.portalList.push({ label: element.Name, value: element.Id });
                    });
                    this.BindDropDownList();
                }
            }));
            this.adminUser = [];
            this.adminUser = this.route.snapshot.data['adminUsers'];
        }

        // Bind business list
        this.businessList = [];
        if(+BaseServices.roleId == UserRole.PORTAL) {
            this.subscriptions.push(this.businessService.getAllPortalBusiness(BaseServices.PortalId,BaseServices.UserId).subscribe((result:any) => {
                if (result) {
                    result.forEach((element:any) => {
                        this.businessList.push({ label: element.CompanyName, value: element.Id });
                    });
                    this.BindDropDownList();
                }
                this.BindListValues();
            })); 
        } else {
            this.subscriptions.push(this.businessService.getAllAdminBusinesses().subscribe((result:any) => {
                if (result) {
                    result.forEach((element:any) => {
                        this.businessList.push({ label: element.CompanyName, value: element.Id });
                    });
                    this.BindDropDownList();
                }
                this.BindListValues();
            }));   
        }
      
        if (BaseServices.roleId === '2') {
            this.selectedType = 'Business';
            this.userRole = 2;
        }
    }

    // Bind dropdown based on selected radio options
    onRadioTypeChange(type: string) {
        this.levelKey = null!;
        this.selectedType = type;
        this.BindDropDownList();
        this.BindListValues();
    }

    onChangeType(type: SelectItem, label: string) {
        this.ShowHideCommonListColumns();
        this.BindListValues();
        this.bindBusinessUserList();
    }


    BindListValues() {
        let ddd = BaseServices.roleId;
        if (BaseServices.roleId === '1') {
            if (this.levelKey == null) {
                this.subscriptions.push(this.manualService.getCommonManualListApplication(BaseServices.ApplicationId)
                    .subscribe((result:any) => { this.CommonManuals = result; }));
            } else {
                if (this.selectedType === 'Portal') {
                    this.roleId = {
                        portalId: this.levelKey ? this.levelKey : 0,
                        businessId: 0
                    };
                    this.subscriptions.push(this.manualService.GetUnassignedManualByPortalLevel(BaseServices.ApplicationId, this.levelKey)
                        .subscribe((result:any) => { this.CommonManuals = result; }));
                        this.subscriptions.push(this.manualService.GetAssignedManualforPortal(this.levelKey).subscribe((result:any) => {
                        this.assignManuals = result;
                    }));
                } else {
                    this.roleId = {
                        portalId: 0,
                        businessId: this.levelKey ? this.levelKey : 0
                    };

                    this.subscriptions.push(this.manualService.GetUnassignedManualByBusinessLevel(BaseServices.ApplicationId, this.levelKey)
                        .subscribe((result:any) => { this.CommonManuals = result; }));
                        this.subscriptions.push(this.manualService.GetAssignedManualforBusiness(this.levelKey).subscribe((result:any) => {
                        this.assignManuals = result;
                    }));
                }
            }
        } else {
            if (this.levelKey == null) {
                this.subscriptions.push(this.manualService.GetCommonAssignManualByPortalLevel(+BaseServices.PortalId).subscribe((result:any) => {
                    this.CommonManuals = result;
                }));
            } else {
                this.subscriptions.push(this.manualService.GetUnassignedManualByBusinessLevelByPortalLogin(+BaseServices.PortalId, this.levelKey)
                    .subscribe((result:any) => { this.CommonManuals = result; }));
                    this.subscriptions.push(this.manualService.GetAssignedManualforBusiness(this.levelKey).subscribe((result:any) => {
                    this.assignManuals = result;
                }));
            }
        }
    }

    ShowHideCommonListColumns() {
        if (this.levelKey != null) {
            this.isAllCommonManual = true;
        } else {
            this.isAllCommonManual = false;
        }

    }

    BindDropDownList() {
        // Bind dropdown based on type

        this.typeList = [];

        if (this.selectedType === 'Portal') {
            this.subscriptions.push(this.translate.stream('SELECT_PORTAL_DROP').subscribe(val => {
                this.typeList = [];
                this.typeList.push(
                    { label: val.SELECT_PORTAL, value: null }
                );
                this.portalList.forEach(element => {
                    this.typeList.push(element);
                });
            }));

            this.levelKey = null!;
        } else {
            this.subscriptions.push(this.translate.stream('SELECT_BUSINESS_DROP').subscribe(val => {
                this.typeList = [];
                this.typeList.push(
                    { label: val.SELECT_BUSINESS, value: null }
                );
                this.businessList.forEach(element => {
                    this.typeList.push(element);
                });
            }));
            this.levelKey = null!;
        }
        if (this.levelKey) {
            this.levelKey = null!;
        }

        this.ShowHideCommonListColumns();
    }

    onBusinessOrPortalManualsEdit(list: ManualView[]) {
        this.BusinessOrPortalList = list;
        this.updateBusinessOrPortalManuals();
    }

    onSelectedCommonManuals(list: ManualView[]) {
        this.selectedCommonList = list;
        this.AddCommonManuals();
    }

    onPortalCommonManualsEdit(list: ManualView[]) {
        this.PortalCommonList = list;
        this.updatePortalCommonManuals();
    }
    updateBusinessOrPortalManuals() {
        if (this.BusinessOrPortalList) {
            const updatedList = this.BusinessOrPortalList.filter(list => list.isUpdate === true);
    
            updatedList.forEach(list => {
                if (list.RefEditedDate) {
                    list.RefEditedDate = this.dateService.formatDateToString(list.RefEditedDate as Date);

                }
            });
    
            const updateService = this.selectedType === 'Portal'
                ? this.manualService.UpdatePortalAssignedManuals(updatedList)
                : this.manualService.UpdateBusinessAssignedManuals(updatedList);
    
            this.subscriptions.push(updateService.subscribe(result => {
                this.BusinessOrPortalList = [];
                this.BindListValues();
                this.showPrimeToast('success', 'Success', 'Manuals updated successfully'); // Show success toast
            }));
        }
    }

    AddCommonManuals() {
        if (this.isAssigning) {
            return;
        }
        this.isAssigning = true;
        this.editCommonManual = [];

        if (this.selectedType === 'Portal') {
            this.levelId = 2;
        } else {
            this.levelId = 3;
        }
        this.levelKey = this.levelKey;
        for (let listvalue of this.selectedCommonList) {
            listvalue.CreatedBy = BaseServices.UserId;
            if (BaseServices.roleId === '1') {
                listvalue.AppManualId = listvalue.Id;
            }
            if (this.selectedType === 'Portal') {
                listvalue.BusinessPortalId = this.levelKey;
            } else {
                listvalue.BusinessId = this.levelKey;
                if (listvalue.BusinessPortalId === null) {
                    listvalue.BusinessPortalId = 0;
                }
            }
        }

        if (this.selectedType === 'Portal') {
            this.subscriptions.push(this.manualService.AddAssignManualsToPortal(this.selectedCommonList).subscribe({
                next: result => {
                    this.isAssigning = false;
                    this.selectedCommonList = [];
                    this.BindListValues();
                    this.showPrimeToast('success', 'Success', 'Manuals assigned to portal successfully');
                },
                error: () => {
                    this.isAssigning = false;
                }
            }));
        } else {
            this.subscriptions.push(this.manualService.AddAssignManualToBusiness(this.selectedCommonList).subscribe({
                next: result => {
                    this.isAssigning = false;
                    this.selectedCommonList = [];
                    this.BindListValues();
                    this.showPrimeToast('success', 'Success', 'Manuals assigned to business successfully');
                },
                error: () => {
                    this.isAssigning = false;
                }
            }));
        }
    }

    updatePortalCommonManuals() {
        if (this.PortalCommonList) {
            this.PortalCommonList = this.PortalCommonList.filter(list => list.isUpdate === true);
            this.subscriptions.push(this.manualService.UpdatePortalCommonManuals(this.PortalCommonList).subscribe(result => {
                this.PortalCommonList = [];
                this.BindListValues();
                this.showPrimeToast('success', 'Success', 'Portal manuals updated successfully'); // Show success toast
            }));
        }
    }


    editManualVersion(versionDetails: ManualVersion) {
        this.manualVersionField = versionDetails.VersionNo;
        this.manualVersionId = versionDetails.Id;
        this.versionDetails = versionDetails;
    }

    bindBusinessUserList() {
        this.userList = [];
        if (this.levelKey != null) {
            if (this.selectedType === 'Portal') {
                this.userList = [];
                this.subscriptions.push(this.translate.stream('SELECT_DROPDOWN').subscribe(val => {
                    this.userList = [];
                    this.userList.push(
                        { label: val.SELECT, value: null }
                    );
                }));
                if (+BaseServices.roleId === 1) {
                    if (this.adminUser && this.adminUser.length > 0) {
                        this.adminUser.forEach(x => {
                            this.userList.push(
                                { label: x.Name, value: x.Id }
                            );
                        });
                    }
                }
                let portal = this.portalList.filter(list =>list.value === this.levelKey || list.value == null);
                if (portal.length > 0) {
                    this.userList.push(
                        { label: portal[0].label, value: portal[0].value }
                    );
                }
            } else {
                this.subscriptions.push(this.manualService.getBusinessUserListForManuals(this.levelKey)
                    .subscribe((result:any) => {
                        this.subscriptions.push(this.translate.stream('SELECT_DROPDOWN').subscribe(val => {
                            this.userList = [];
                            this.userList.push(
                                { label: val.SELECT, value: null }
                            );
                        }));
                        if (+BaseServices.roleId === 1) {
                            this.userList.push(
                                { label: BaseServices.name, value: BaseServices.UserId }
                            );
                        }
                        result.forEach((element:any) => {
                            this.userList.push({ label: element.Name, value: element.Id });
                        });
                        this.BindListValues();
                    }));
            }
        }
    }

    onDeleteAssignedManual(manualDetails: any) {
        this.confirmationService.confirm({
            message: this.translate.instant('ARE_SURE_TO_PERFORM_ACTION'),
            accept: () => {
                const request = this.selectedType === 'Portal'
                    ? this.manualService.deletePortalAssignedManual(manualDetails)
                    : this.manualService.deleteBusinessAssignedManual(manualDetails);
                this.subscriptions.push(request.subscribe({
                    next: result => {
                        if (result !== true) {
                            this.messageService.error('MANUAL_ACTION_FAILED');
                            return;
                        }
                        this.BindListValues();
                        this.messageService.success('UI_NOTIFICATIONS.DELETED');
                    },
                    // HTTP failures are already reported by the interceptor.
                    error: () => {}
                }));
            }
        });
    }

    ngOnDestroy() {
        this.subscriptions.forEach((sub, i) => {
            sub.unsubscribe();
        });
    }

    // Add this helper method for PrimeNG Toast
    showPrimeToast(severity: string, summary: string, detail: string) {
        this.messageService.add({
            severity,
            summary,
            detail,
            life: 3000
        });
    }
}
